import { useQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';

import { Job } from 'src/types/gojob';

export const OfferQuery = gql`
  query OfferQuery($shortId: String, $id: ID) {
    job(shortId: $shortId, id: $id) {
      id
      shortId
      caption
      city
      postalCode
      weeklyHours
      totalWorkingDays
      location {
        lat
        lon
      }
      salary {
        grossHourlyRate
        grossHourlyRateIncludingIFMAndCP
        grossHourlyRateIncludingCP
        monthlySalary
        monthlySalaryIncludingIFMAndCP
        monthlyCP
        totalCP
        totalIFM
        totalSalary
      }
      advertisement
      activitiesDetail
      wantedProfile
      gojobMessage
      computerSkills
      languageSkills {
        caption
        level
      }
      certifications
      timeTables {
        day
        ranges {
          start
          end
        }
      }
      from
      to
      publishedAt
    }
  }
`;

type Ids = {
  shortId?: string;
  id?: string;
};

const useOffer = (ids: Ids, skip?: boolean) => {
  const { shortId, id } = ids;
  const { data, loading, error } = useQuery<{ job?: Job }>(OfferQuery, { skip, variables: { shortId, id } });
  /** If job is not found, no graphql error and data.job = null */
  if (!skip && !loading && !data?.job) {
    return {
      loading,
      error: true,
    };
  }
  return { data, loading, error };
};

export default useOffer;
